// extracted by mini-css-extract-plugin
module.exports = {"container":"hB","image":"hC","title":"hD","date":"hE"};